var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1474,
    height: 332,
    viewBox: "0 0 1474 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 20V110.911H263.771H1241H1252.91V20H68Z",
    fill: "#668BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 20V323H219.771V110.911H1197H1208.91V20H24Z",
    fill: "#668BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253 19.0469H4V40.2092H1253V19.0469Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 111.043H24V116.723H219V111.043Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 39.9917H219V116.992H220V39.9917Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 184.225H24V190.908H219V184.225Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 316.992H24V323.675H219V316.992Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 247.992H24V254.675H219V247.992Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 105.992H24V111.672H219V105.992Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 179.174H24V185.856H219V179.174Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 242.94H24V249.623H219V242.94Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.751 155.934H101.81C100.271 155.934 99 153.818 99 151.256C99 148.695 100.271 146.578 101.81 146.578H140.751C142.29 146.578 143.562 148.695 143.562 151.256C143.562 153.818 142.29 155.934 140.751 155.934Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.002 150.143H106.495C105.29 150.143 104.354 148.583 104.354 146.578C104.354 144.574 105.29 143.014 106.495 143.014H136.002C137.206 143.014 138.143 144.574 138.143 146.578C138.143 148.583 137.206 150.143 136.002 150.143Z",
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.751 86.3214H101.81C100.271 86.3214 99 84.2051 99 81.6434C99 79.0816 100.271 76.9653 101.81 76.9653H140.751C142.29 76.9653 143.562 79.0816 143.562 81.6434C143.562 84.2051 142.29 86.3214 140.751 86.3214Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.002 80.5295H106.495C105.29 80.5295 104.354 78.9702 104.354 76.9653C104.354 74.9605 105.29 73.4011 106.495 73.4011H136.002C137.206 73.4011 138.143 74.9605 138.143 76.9653C138.143 78.9702 137.206 80.5295 136.002 80.5295Z",
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.751 295.533H101.81C100.271 295.533 99 293.417 99 290.855C99 288.293 100.271 286.177 101.81 286.177H140.751C142.29 286.177 143.562 288.293 143.562 290.855C143.562 293.417 142.29 295.533 140.751 295.533Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.002 289.741H106.495C105.29 289.741 104.354 288.182 104.354 286.177C104.354 284.172 105.29 282.613 106.495 282.613H136.002C137.206 282.613 138.143 284.172 138.143 286.177C138.143 288.182 137.206 289.741 136.002 289.741Z",
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.751 225.92H101.81C100.271 225.92 99 223.804 99 221.242C99 218.68 100.271 216.564 101.81 216.564H140.751C142.29 216.564 143.562 218.68 143.562 221.242C143.562 223.804 142.29 225.92 140.751 225.92Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.002 220.128H106.495C105.29 220.128 104.354 218.569 104.354 216.564C104.354 214.559 105.29 213 106.495 213H136.002C137.206 213 138.143 214.559 138.143 216.564C138.143 218.569 137.206 220.128 136.002 220.128Z",
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253 0.999756H23.6693L4 19.0471H1253V0.999756Z",
    fill: "#B0C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406 20V110.911H1210.23H233H221.087V20H1406Z",
    fill: "#668BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450 20V323H1254.23V110.911H277H265.087V20H1450Z",
    fill: "#668BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 19.0469H1470V40.2092H221V19.0469Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255 111.043H1450V116.723H1255V111.043Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254 39.9917H1255V116.992H1254V39.9917Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255 184.225H1450V190.908H1255V184.225Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255 316.992H1450V323.675H1255V316.992Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255 247.992H1450V254.675H1255V247.992Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255 105.992H1450V111.672H1255V105.992Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255 179.174H1450V185.856H1255V179.174Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255 242.94H1450V249.623H1255V242.94Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.25 155.934H1372.19C1373.73 155.934 1375 153.818 1375 151.256C1375 148.695 1373.73 146.578 1372.19 146.578H1333.25C1331.71 146.578 1330.44 148.695 1330.44 151.256C1330.44 153.818 1331.71 155.934 1333.25 155.934Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338 150.143H1367.51C1368.71 150.143 1369.65 148.583 1369.65 146.578C1369.65 144.574 1368.71 143.014 1367.51 143.014H1338C1336.79 143.014 1335.86 144.574 1335.86 146.578C1335.86 148.583 1336.79 150.143 1338 150.143Z",
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.25 86.3214H1372.19C1373.73 86.3214 1375 84.2051 1375 81.6434C1375 79.0816 1373.73 76.9653 1372.19 76.9653H1333.25C1331.71 76.9653 1330.44 79.0816 1330.44 81.6434C1330.44 84.2051 1331.71 86.3214 1333.25 86.3214Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338 80.5295H1367.51C1368.71 80.5295 1369.65 78.9702 1369.65 76.9653C1369.65 74.9605 1368.71 73.4011 1367.51 73.4011H1338C1336.79 73.4011 1335.86 74.9605 1335.86 76.9653C1335.86 78.9702 1336.79 80.5295 1338 80.5295Z",
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.25 295.533H1372.19C1373.73 295.533 1375 293.417 1375 290.855C1375 288.293 1373.73 286.177 1372.19 286.177H1333.25C1331.71 286.177 1330.44 288.293 1330.44 290.855C1330.44 293.417 1331.71 295.533 1333.25 295.533Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338 289.741H1367.51C1368.71 289.741 1369.65 288.182 1369.65 286.177C1369.65 284.172 1368.71 282.613 1367.51 282.613H1338C1336.79 282.613 1335.86 284.172 1335.86 286.177C1335.86 288.182 1336.79 289.741 1338 289.741Z",
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.25 225.92H1372.19C1373.73 225.92 1375 223.804 1375 221.242C1375 218.68 1373.73 216.564 1372.19 216.564H1333.25C1331.71 216.564 1330.44 218.68 1330.44 221.242C1330.44 223.804 1331.71 225.92 1333.25 225.92Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338 220.128H1367.51C1368.71 220.128 1369.65 218.569 1369.65 216.564C1369.65 214.559 1368.71 213 1367.51 213H1338C1336.79 213 1335.86 214.559 1335.86 216.564C1335.86 218.569 1336.79 220.128 1338 220.128Z",
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 0.999756H1450.33L1470 19.0471H221V0.999756Z",
    fill: "#B0C3D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 1474,
    height: 332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabTable);
export default __webpack_public_path__ + "static/media/LabTable.a03103570f29b69b587edc695e8eba7c.svg";
export { ForwardRef as ReactComponent };